import { ReportOpts } from "web-vitals";

const reportWebVitals = (onPerfEntry?: ReportOpts) => {
  if (onPerfEntry && typeof onPerfEntry === "function") {
    import("web-vitals")
      .then(({ onCLS, onFCP, onLCP, onTTFB }) => {
        onCLS(onPerfEntry);
        onFCP(onPerfEntry);
        onLCP(onPerfEntry);
        onTTFB(onPerfEntry);
      })
      .catch((error) => {
        console.error("Failed to load web-vitals:", error);
      });
  }
};

export default reportWebVitals;
